import { getByToken } from 'service/base';
import { LocalStorageKey } from 'utils/common/const';

const { selector } = require('recoil');

export const selectorUserInfo = selector({
  key: 'selectorUserInfoUnique',
  get: async () => {
    const accessToken = localStorage.getItem(LocalStorageKey.ACCESS_TOKEN);
    if (!accessToken) return null;

    try {
      const res = await getByToken();
      if (res?.code !== 0 || res?.status_code) return null;
      return res?.data;
    } catch (error) {
      console.error('selectorUserInfo error:', error?.message || error);
      return null;
    }
  }
});
